import { FC } from 'react';
import { Feature } from '../../../../services/backstage/Feature';
import { ReadEmployee } from '../../../../services/gql/graphql.generated';
import { TeamMemberCard } from './TeamMemberCard';
import { TeamMemberPayCard } from './TeamMemberPayCard';

interface OverviewSectionProps {
  editMemberCard?: boolean;
  editMemberPayCard?: boolean;
  userData: ReadEmployee;
}

export const overviewSectionId = 'overview-section';

export const OverviewSection: FC<OverviewSectionProps> = ({ userData, editMemberCard, editMemberPayCard }) => {
  return (
    <section id={overviewSectionId}>
      {!userData.isDeleted && (
        <div className="grid grid-cols-1 md:grid-cols-2 md:auto-rows-min gap-4">
          <div>
            <TeamMemberCard enableEdit={editMemberCard} employee={userData} />
          </div>
          <Feature name="pay">
            <div>
              <TeamMemberPayCard enableEdit={editMemberPayCard} employee={userData} />
            </div>
          </Feature>
        </div>
      )}
    </section>
  );
};
